import ItemsDetailsMobileWrapper from 'components/ItemsDetailsMobileWrapper'
import ItemHeader from 'containers/ManageAccess/ItemHeader'
import { useIsSmallScreen } from 'packages/core'
import { Loader } from 'packages/eid-ui'
import { useComputerLoginSessionHistoryDetail } from 'hooks'
import LoginHistoryAccessDetails from './LoginHistoryAccessDetails'
import { ManageAccessDrawer } from 'components/Drawer/ManageAccessDrawer'

const ComputerLoginHistoryAccessDrawer = ({
    id,
    attributes,
    toggleDrawer,
    ...rest
}) => {
    const isSmallScreen = useIsSmallScreen()
    const headerAttribute = attributes.find((x) => x.isHeader)

    const { data: loginHistorySessionDetails } =
        useComputerLoginSessionHistoryDetail(id)

    let item
    if (loginHistorySessionDetails) {
        item = {
            resource: loginHistorySessionDetails,
        }
    }

    const itemDetails = <LoginHistoryAccessDetails item={item} {...rest} />

    return isSmallScreen ? (
        <ItemsDetailsMobileWrapper toggleDrawer={toggleDrawer}>
            <ItemHeader title={item?.resource?.[headerAttribute.name]} />
            {!item && <Loader />}
            {item && itemDetails}
        </ItemsDetailsMobileWrapper>
    ) : (
        <ManageAccessDrawer
            id={id}
            toggleDrawer={toggleDrawer}
            item={item}
            itemDetails={itemDetails}
            headerAttribute={headerAttribute}
        />
    )
}

export default ComputerLoginHistoryAccessDrawer
